/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class SetupAwsPrivateLinkResponse {
  /**
  * Temporal workflow ID of the SetupAwsPrivateLink flow.
  */
  'workflowId': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "workflowId",
      "baseName": "workflowId",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SetupAwsPrivateLinkResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

